import { o_global } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const debugSync = /*           */ asExport(o_global, "debug", {});
const logger = /*           */ asExport(debugSync, "logger", noop);
const scope = /*           */ asExport(debugSync, "scope", noop);
const Level = /*           */ asExport(debugSync, "Level", noop);
const status = /*           */ asExport(debugSync, "status", noop);
export {
  Level,
  debugSync,
  logger,
  scope,
  status
};
/*                                     */
